import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TitleBreadbreadcrumbComponent } from 'src/app/shared/title-breadbreadcrumb/title-breadbreadcrumb.component';

const routes: Routes = [
  {
      path: '',
      component: TitleBreadbreadcrumbComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TitleBreadbreadcrumbRoutingModule { }
